import * as React from 'react';

import { Moment } from 'moment';
import { daysOfWeek, weeksOfMonth } from './dateUtils';
// import { getMods, getModsByCompType } from './util';
import Week from './Week';

interface Props {
    date: Moment;
    monthNameFormat?: string;
    weekdayFormat?: string;
    selected: Moment[];
    newlySelected: Moment[];
    onToggle: (day: Moment) => void;    
}

export default class Calendar extends React.PureComponent<Props> {
    public static defaultProps = {
        monthNameFormat: 'MMMM YYYY',
        monthNames: true,
        weekdayFormat: 'dd',
        weekdayNames: true
    };

    constructor(props: Props) {
        super(props);
    }

    public render() {
        const { date, selected, newlySelected, onToggle, monthNameFormat} = this.props;

        return (
            <div className={'rc-Month'}>
                <header key="header" className={'rc-Month-header'}>
                    {date.format(monthNameFormat)}
                </header>
                {this.renderWeekHeader(this.props)}
                {weeksOfMonth(date).map((wDate, i) => (
                    <Week key={`week-${i}`} date={wDate} month={date} selected={selected} newlySelected={newlySelected} onToggle={onToggle}/>
                ))}
            </div>
        );
    }

    private renderWeekHeader = (props: Props) => {
        return (
            <div className={'rc-Month-weekdays'}>
                <div className={'rc-Month-weekdays-weekday soft'}>KW</div>
                {daysOfWeek(props.date).map((weekday, i) => (
                    <div key={`weekday-header-${i}`} className={'rc-Month-weekdays-weekday'}>
                        {weekday.format(props.weekdayFormat)}
                    </div>
                ))}
            </div>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/calendar/Month.tsx